import { render, staticRenderFns } from "./JWL_UndoPublish.vue?vue&type=template&id=01712cc1&lang=pug&"
import script from "./JWL_UndoPublish.vue?vue&type=script&lang=ts&"
export * from "./JWL_UndoPublish.vue?vue&type=script&lang=ts&"
import style0 from "./JWL_UndoPublish.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports